import { Task } from './task.model'
import {WpMessages} from './WpMessages';
import {Appointment} from './appointment.model';
import {AppointmentChart} from './appointmentChart';
import {TaskChart} from "./TaskChart";
import {WpProvider} from "./wp-provider.model";
import {Announcement}from "./announcements.model";
import {ReferralChart} from "./ReferralChart";
import {ApptChart} from "./ApptChart";


export class ProviderDashboardSearch {
  constructor(

    public counties?: any,
    public userId?: number,
    public workerTasks ?: Task[],

    public task?: Task,
    public pendingTasks ?: Task[],
    public taskDueDateFrom?: any,
    public taskDueDateTo ?: any,
    public todayDate ?: any,

    public wpAppointment?: Appointment,
    public upcomingAppointments ?: Appointment[],


    public  apptChart ?: ApptChart,

    public taskChart ?: TaskChart,

    public referralChart ?: ReferralChart,



    public announcements ?: Announcement[],

  ) {
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/model/ProviderDashboardSearch.ts